import AnimatedSection from '../../../components/base/AnimatedSection';

export default function PartnersSection() {
  const partners = [
    {
      name: 'Dijital Hotel Management',
      logo: 'https://public.readdy.ai/ai/img_res/09d425bf-c9b0-4b35-a43c-be811d57168f.png',
      link: 'https://www.digitalhotelmanagement.com/#kayit',
    },
    {
      name: 'Hotel Runner',
      logo: 'https://public.readdy.ai/ai/img_res/ac1f8868-a4b5-4c55-9ee9-bbb3b5c88b54.png',
      link: 'https://app.hotelrunner.com/signup?partner_code=47c495',
    },
    {
      name: 'Pricing Coach',
      logo: 'https://public.readdy.ai/ai/img_res/4690d435-2d6c-4ddb-b9bf-f129583890e0.png',
      link: '',
    },
  ];

  return (
    <section id="references" className="relative py-24 bg-gradient-to-br from-[#0B1D3A] via-[#0F2847] to-[#0B1D3A] overflow-hidden">
      {/* Decorative */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37]/40 to-transparent"></div>
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37]/40 to-transparent"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <AnimatedSection animation="fadeUp">
          {/* Başlık */}
          <div className="text-center mb-16">
            <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#D4AF37]/20 text-[#D4AF37] rounded-full text-sm font-semibold mb-6 border border-[#D4AF37]/30">
              <i className="ri-shake-hands-line text-lg"></i>
              Güvenilir Ağımız
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              İş Ortaklarımız
            </h2>
            <p className="text-white/70 text-lg max-w-2xl mx-auto">
              Sektörün önde gelen platformlarıyla güçlü iş birlikleri
            </p>
          </div>

          {/* Logo Grid */}
          <div className="flex flex-wrap justify-center items-center gap-10">
            {partners.map((partner, index) => (
              <a
                key={index}
                href={partner.link || undefined}
                target={partner.link ? '_blank' : undefined}
                rel={partner.link ? 'noopener noreferrer' : undefined}
                className="bg-white/90 hover:bg-white border border-white/20 hover:border-[#D4AF37]/60 rounded-2xl p-4 flex items-center justify-center transition-all duration-300 hover:scale-105 cursor-pointer shadow-lg"
                style={{ width: '280px', height: '150px' }}
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="w-full h-full object-contain transition-all duration-300"
                />
              </a>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
